if (!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
    class ProductMedia extends HTMLElement {
        constructor() {
            super();
            this.mainElement = this.closest('#main-product-' + this.dataset['section'])
            this.itemsWrapper = this.querySelector(':scope > div');
            this.productData = JSON.parse(this.mainElement.querySelector('[type="application/json"]').textContent);
            this.desktopStyle = this.dataset.desktop;
            this.mobileStyle = this.dataset.mobile;
            this.slider = false;

            this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
            window.addEventListener('mediaChange', this.onMediaChange.bind(this))
            setTimeout(() => {
                this.onMediaChange();
            }, 10);
        }

        filterMedia(variant) {
            this.productData.media.forEach((media, i) => {
                var show = true;
                if (media.alt && media.alt != "") {
                    var filter = media.alt.split(';');
                    filter.forEach((f) => {
                        if (show) {
                            var key = f.split(':')[0];
                            var values = f.split(':')[1];
                            var optionIndex = this.productData.options.findIndex(x => x == key);
                            if (optionIndex >= 0) {
                                var found = false;
                                values.split(',').forEach((value) => {
                                    if (variant.options[optionIndex] == value) {
                                        found = true;
                                    }
                                });
                                show = found;
                            }
                        }
                    });
                }
                if (show) {               
                    this.querySelector('[data-media-id="' + media.id + '"]').style.display = 'block';                
                } else {
                    this.querySelector('[data-media-id="' + media.id + '"]').style.display = 'none';                
                }
            });
            if (this.slider) {
                this.slider.refresh();
            }
        }

        onVariantChange() {}

        onMediaChange() {}

        initSlider() {}

        removeSlider() {
            if (this.slider) {
                this.slider.destroy();
                this.slider = false;
                this.classList.remove('keen');
                this.itemsWrapper.classList.remove('keen-slider');
                this.querySelectorAll(':scope > div').forEach((slide) => {
                    slide.classList.remove('keen-slider-slide')
                });
            }
        }

        showItem(mediaId, animate = true) {
            if (this.slider) {
                var index = Array.from(this.itemsWrapper.querySelectorAll(':scope > div'))
                    .filter(x => $s.isVisible(x)).findIndex(x => x.dataset.mediaId == mediaId);
                if (animate) {
                    this.slider.moveToSlideRelative(index, true);
                } else {
                    this.slider.moveToSlideRelative(index, true, 0);
                }
            }
        }
    }

    class ProductGallery extends ProductMedia {
        constructor() {
            super();

            if (!this.closest('.tingle-modal')) {
                this.querySelectorAll('[data-file]').forEach((media) => {
                    media.addEventListener('click', (e) => {
                        var visibleItems = [];
                        this.querySelectorAll('[data-media-id]').forEach((obj) => {
                            if ($s.isVisible(obj)) {
                                let element = obj.querySelector('[data-file], video, iframe');
                                if (element) {
                                    visibleItems.push(element);
                                }
                            }
                        });
                        $s.photoSwipe(visibleItems, media);
                    });
                });
                //3D Models
                this.querySelectorAll('[data-media-id].model-wrap').forEach((model) => {
                    model.addEventListener('click', (e) => {
                        $s.photoSwipe([model.querySelector('template').content.firstElementChild]);
                    });
                });
            }
        }

        onVariantChange(e) {
            var variant = e.detail.variant;
            var animate = e.detail.animate;
            if (this.productData.media && variant) {
                this.filterMedia(variant)
                if (variant.featured_media) {
                    this.showItem(variant.featured_media.id, animate)
                }
            }
        }

        onMediaChange() {
            if ($s.media.isSmall || this.desktopStyle == 'carousel') {
                this.initSlider();
            } else {
                this.removeSlider();
            }
        }

        initSlider() {
            if (!this.slider) {
                this.classList.add('keen');
                this.itemsWrapper.classList.add('keen-slider');
                this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide) => {
                    slide.classList.add('keen-slider-slide')
                });

                var breakpoints = {};
                if (this.mobileStyle == 'dots') {
                    breakpoints['(max-width: ' + window.breakpoints.small + ')'] = {
                        dots: this.querySelector('.keen-dots')
                    }
                }
                if (this.querySelector('.keen-arrow')) {
                    breakpoints['(min-width: ' + (parseInt(window.breakpoints.small) + 1) + 'px)'] = {
                        prevButton: this.querySelector('.keen-arrow.prev'),
                        nextButton: this.querySelector('.keen-arrow.next')
                    }
                }

                this.slider = new KeenSlider(this.itemsWrapper, {
                    mode: "snap",
                    loop: false,
                    wheel: false,
                    controls: this.dataset.carouselControls === '1' ? false : true,
                    customAnimation: 'fade',
                    prevButton: this.querySelector('.keen-arrow.prev'),
                    nextButton: this.querySelector('.keen-arrow.next'),
                    slideChanged: (keen) => {
                        this.dispatchEvent(new CustomEvent('slideChanged', { detail: keen }));
                    },
                    // breakpoints
                });
            }
        }
    }
    customElements.define('product-gallery', ProductGallery);

    class ProductThumbs extends ProductMedia {
        constructor() {
            super();
            this.mainGallery = this.mainElement.querySelector('product-gallery');

            this.querySelectorAll('[data-media-id]').forEach((media) => {
                media.addEventListener('click', (e) => {
                    this.mainGallery.showItem(media.dataset.mediaId);
                });
            });

            this.mainGallery.addEventListener('slideChanged', (e) => {
                var keen = e.detail;
                var currentMediaId = keen.currentSlide().dataset.mediaId;
                var currentSlideElement = this.querySelector('.current-slide');
                if (currentSlideElement) {
                    currentSlideElement.classList.remove('current-slide');
                }
                this.querySelector('[data-media-id="' + currentMediaId + '"]').classList.add('current-slide');
            });
        }

        onVariantChange(e) {
            var variant = e.detail.variant;
            if (this.productData.media && variant) {
                this.filterMedia(variant)
            }
        }

        onMediaChange() {
            if (($s.media.isSmall && this.mobileStyle == 'thumbnails') || ($s.media.isMediumUp && this.desktopStyle == 'carousel')) {
                this.style.display = 'block';
                this.initSlider();
            } else {
                this.style.display = 'none';
                this.removeSlider();
            }
        }

        initSlider() {
            if (!this.slider) {
                this.classList.add('keen');
                this.itemsWrapper.classList.add('keen-slider');
                this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide) => {
                    slide.classList.add('keen-slider-slide')
                });
                var breakpoints = {};
                breakpoints['(max-width: ' + window.breakpoints.medium + ')'] = {
                    slidesPerView: 4,
                    spacing: 10
                }
                breakpoints['(max-width: ' + window.breakpoints.small + ')'] = {
                    slidesPerView: 5,
                    spacing: 10
                }
                this.slider = new KeenSlider(this.itemsWrapper, {
                    mode: "snap",
                    loop: true,
                    centered: true,
                    slidesPerView: 7,
                    spacing: 15,
                    prevButton: this.querySelector('.keen-arrow.prev'),
                    nextButton: this.querySelector('.keen-arrow.next'),
                    breakpoints
                });
            }
        }
    }
    customElements.define('product-thumbs', ProductThumbs);
}

if (!customElements.get('product-price')) {
    class ProductPrice extends HTMLElement {
        constructor() {
            super();
            this.mainElement = this.closest('#main-product-' + this.dataset['section'])
            this.dealElement = this.querySelector('.deal')
            this.retailElement = this.querySelector('.retail')
            this.savingsPercentageElement = this.querySelector('.savings-percentage');

            this.circleElement = this.querySelector('.text p');

            this.variantsElement = this.mainElement.querySelector('product-variants');

            ['variantChange', 'sellingPlanChange'].forEach((event) => {
                this.mainElement.addEventListener(event, (e) => {
                    var data = e.detail.variant || e.detail.sellingPlan;
                    if (!data) {
                        data = this.variantsElement.getCurrentVariant();
                    }
                    if (data) {
                        this.dealElement.innerHTML = this.dealElement.dataset.noZeros ? $s.formatMoney(data.price).replace('.00','') : $s.formatMoney(data.price) ;

                        if (data.compare_at_price > data.price) {
                            this.retailElement.classList.remove('hide');
                            this.retailElement.innerHTML = this.retailElement.dataset.noZeros ? $s.formatMoney(data.compare_at_price).replace('.00','') : $s.formatMoney(data.compare_at_price);
                            
                            // update savings percentage
                            if (this.savingsPercentageElement) {
                                var savingsPercentage = Math.floor((data.compare_at_price - data.price) * 100 / data.compare_at_price);
                                this.savingsPercentageElement.textContent = '(' + savingsPercentage + '% off)';
                                this.savingsPercentageElement.classList.remove('hide');
                            }
                        } else {
                            this.retailElement.classList.add('hide');
                            this.retailElement.innerHTML = '';
                            
                            // hide savings percentage
                            if (this.savingsPercentageElement) {
                                this.savingsPercentageElement.classList.add('hide');
                            }
                        }
                    } else {
                        this.dealElement.innerHTML = '';
                        this.retailElement.innerHTML = '';
                        if (this.savingsPercentageElement) {
                            this.savingsPercentageElement.classList.add('hide');
                        }
                    }
                });
            });

            if (this.circleElement) {
                this.circleElement.innerHTML = this.circleElement.innerHTML.split("").map(
                    (char, i) =>
                    `<span style="transform:rotate(${i * 15}deg)">${char}</span>`
                ).join("")
            }
        }
    }
    customElements.define('product-price', ProductPrice);
}

if (!customElements.get('product-variants')) {
    class ProductVariants extends HTMLElement {
        constructor() {
            super();
            this.mainElement = this.closest('#main-product-' + this.dataset['section'])
            this.productData = JSON.parse(this.mainElement.querySelector('[type="application/json"]').textContent);
            this.variantInput = this.querySelector('[data-variant-id]');

            this.bindOptions();
            setTimeout(() => {
                this.variantChange(this.getCurrentVariant(), false);
            }, 10);
        }

        getCurrentVariant() {
            return this.productData.variants.find(x => x.id == this.variantInput.value)
        }

        setVariant(variant) {
            if (typeof variant !== 'object') {
                variant = this.productData.variants.find(x => x.id == variant);
            }
            if (variant) {
                this.refreshOptions(-1, variant);
                this.variantChange(variant);
            }
        }

        variantChange(variant, animate = true) {
            if (variant) {
                this.variantInput.value = variant.id;
            } else {
                this.variantInput.value = '';
            }
            this.previousVariant = variant;
            this.variantInput.dispatchEvent(new Event('change', { bubbles: true }))
            this.mainElement.dispatchEvent(new CustomEvent('variantChange', { detail: { variant, animate } }));
            this.showDelayMessage(variant);

            // Pushing a new state to the URL so Klaviyo can detect variant change
            const url = new URL(window.location);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
        }

        showDelayMessage(variant) {
          this.shippingDelay = this.mainElement.querySelector('.shipping-delay');
          // Shipping Delay
          if (variant && variant.metafields && variant.metafields.delay && this.shippingDelay) {
              this.shippingDelay.innerHTML = variant.metafields.delay;
              this.shippingDelay.classList.add('visible');
          } else if (this.shippingDelay){
            this.shippingDelay.classList.remove('visible');
              this.shippingDelay.innerHTML = '';
          }
        }

        calculateNewVariant(optionChanged, value) {
            var newVariants = this.productData.variants;
            this.productData.options.forEach((option, index) => {
                if (optionChanged == index) {
                    newVariants = newVariants.filter(x => x.options[index] == value);
                } else {
                    var tmpNewVariants = newVariants.filter(x => x.options[index] == this.previousVariant.options[index]);
                    if (tmpNewVariants.length == 0) {
                        tmpNewVariants = newVariants.filter(x => x.options[index] == newVariants[0].options[index]);
                    }
                    newVariants = tmpNewVariants;
                }
            });
            return newVariants[0];
        }

        bindOptions() {
            this.querySelectorAll('[data-option]').forEach((element) => {
                element.addEventListener('change', (e) => {
                    let optionIdx = element.dataset.option - 1;
                    let variant = this.calculateNewVariant(optionIdx, e.target.value);
                    this.refreshOptions(element.dataset.option - 1, variant);
                    this.variantChange(variant);
                });
            });
        }

        getOptionValues(currentVariant) {
            var options = [];
            this.productData.options.forEach((option, index) => {
                if (index == 0) {
                    var optionValues = this.productData.variants.map((variant) => {
                      var hiddenVariant = false
                      if (variant.metafields.hide != undefined) {
                          if (variant.metafields.hide) {
                              hiddenVariant = true
                          }
                      }
                      return {
                          value: variant.options[index],
                          available: variant.available,
                          hiddenVariant: hiddenVariant
                      }
                    });
                }
                if (index == 1) {
                    var optionValues = this.productData.variants.filter(x => x.options[0] == currentVariant.option1).map((variant) => {
                      var hiddenVariant = false
                      if (variant.metafields.hide != undefined) {
                          if (variant.metafields.hide) {
                              hiddenVariant = true
                          }
                      }
                      return {
                          value: variant.options[index],
                          available: variant.available,
                          hiddenVariant: hiddenVariant
                      }
                    });
                }
                if (index == 2) {
                    var optionValues = this.productData.variants.filter(
                        x => x.options[0] == currentVariant.option1 && x.options[1] == currentVariant.option2
                    ).map((variant) => {
                      var hiddenVariant = false
                      if (variant.metafields.hide != undefined) {
                          if (variant.metafields.hide) {
                              hiddenVariant = true
                          }
                      }
                      return {
                          value: variant.options[index],
                          available: variant.available,
                          hiddenVariant: hiddenVariant
                      }
                    });
                }
                var optionValuesUnique = [];
                optionValues.forEach((option, key) => {
                    if (!optionValuesUnique.find(x => x.value == option.value)) {
                        if (option.available) {
                            optionValuesUnique.push(option);
                        } else {
                            if (!optionValues.find((x, y) => y != key && x.available && x.value == option.value)) {
                                optionValuesUnique.push(option);
                            }
                        }
                    }
                });
                options.push(optionValuesUnique);
            });
            return options;
        }

        refreshOptions(updateOptionIndex = -1, currentVariant) {
            var optionValues = this.getOptionValues(currentVariant);
            var variantBundleTitle = this.mainElement.querySelector('.variant-bundle-title');
            var fragranceTexts = this.mainElement.querySelectorAll('.fragrance-texts')
            var fragranceTextsVariant = this.mainElement.querySelector(`.fragrance-texts.variant-${currentVariant.id}`)
            this.querySelectorAll('[data-option]').forEach((element, index) => {
                if (index > updateOptionIndex) {
                    element.buildOptions(optionValues[index], currentVariant.options[index]);
                }
                var optionValueElement = element.querySelector('.option-value');
                if (optionValueElement) {
                    optionValueElement.innerHTML = currentVariant.options[index];
                }
                if(variantBundleTitle){
                    variantBundleTitle.innerHTML = currentVariant.options[index];
                }
                var optionValueHeading = this.mainElement.querySelector('.heading-fragrance');
                if (optionValueHeading) optionValueHeading.innerHTML = currentVariant.options[0];

                if(fragranceTexts) fragranceTexts.forEach(fragranceText => fragranceText.style.display = 'none');
                if(fragranceTextsVariant) fragranceTextsVariant.style.display = 'block';
            });
        }
    }
    customElements.define('product-variants', ProductVariants);
}

if (!customElements.get('product-buttons')) {
    class ProductButtons extends HTMLElement {
        constructor() {
            super();
            this.mainElement = this.closest('#main-product-' + this.dataset['section'])
            this.variantsElement = this.mainElement.querySelector('product-variants');

            ['variantChange', 'sellingPlanChange'].forEach((event) => {
                this.mainElement.addEventListener(event, (e) => {
                    var data = e.detail.variant || e.detail.sellingPlan;
                    var variant = this.variantsElement.getCurrentVariant();
                    var preOrder = variant && variant.metafields && variant.metafields.is_preorder ? variant.metafields.is_preorder : false;
                    var bundleCard = this.closest('.bundle-card')
                    var freeShippingMessage = this.mainElement.querySelector('.free-shipping-message')
                    if (!data) {
                        data = variant;
                    }
                    if (variant.available) {
                        !bundleCard ? this.innerHTML = `<button type="submit" class="btn add">${ preOrder ? 'PREORDER' : 'ADD TO CART'}<span class="variant-price hide"> - ` + $s.formatMoney(data.price).replace('.00', '') + `</span></button>`: !this.querySelector('button').getAttribute('disabled') ? this.querySelector('button').disabled = false : '';
                        document.querySelector(".quantity-box").classList.remove("hide");

                        if(freeShippingMessage) freeShippingMessage.classList.remove('hide');
                        if(bundleCard){                            
                            this.mainElement.querySelector(".quick-view-bundle-trigger").innerHTML = 'Add to set';
                            this.mainElement.querySelector(".quick-view-bundle-trigger").classList.remove('btn-disabled');
                        }
                    } else {
                        !bundleCard ? this.innerHTML = `` : this.querySelector('button').disabled = true;
                        document.querySelector(".quantity-box").classList.add("hide");
                        
                        if(freeShippingMessage) freeShippingMessage.classList.add('hide');
                        if(bundleCard){                            
                            this.mainElement.querySelector(".quick-view-bundle-trigger").innerHTML = 'Not Available';
                            this.mainElement.querySelector(".quick-view-bundle-trigger").classList.add('btn-disabled');
                        } 
                        
                    }
                });
            });
        }
    }
    customElements.define('product-buttons', ProductButtons);
}

// add-on checkbox behavior as a custom element
if (!customElements.get('product-add-on')) {
    class ProductAddOn extends HTMLElement {
        constructor() {
            super();
            this.sectionId = this.dataset['section'];
            this.mainElement = this.closest('#main-product-' + this.sectionId);
            this.productData = JSON.parse(this.mainElement.querySelector('[type="application/json"]').textContent);
            this.variantsElement = this.mainElement.querySelector('product-variants');
            this.container = this.querySelector('.addon-product');
            this.checkbox = this.container ? this.container.querySelector('.addon-checkbox') : null;
            this.hiddenInputs = this.container ? this.container.querySelectorAll('input[type="hidden"]') : [];
            this.learnBtn = this.container ? this.container.querySelector('.addon-learn-more') : null;
            this.learnContent = this.container ? this.container.querySelector('#addon-content-' + this.sectionId) : null;

            this.syncAddonState = this.syncAddonState.bind(this);
            this.updateAddOn = this.updateAddOn.bind(this);
            this.bind();
            
            // listen for variant changes
            if (this.mainElement) {
                this.mainElement.addEventListener('variantChange', (e) => {
                    this.updateAddOn(e.detail.variant);
                });
            }
        }

        bind(){
            if (this.checkbox){
                this.checkbox.addEventListener('change', this.syncAddonState);
                this.syncAddonState();
            }
            if (this.learnBtn && this.learnContent){
                this.learnBtn.addEventListener('click', () => {
                    var isHidden = this.learnContent.hasAttribute('hidden');
                    if (isHidden){
                        this.learnContent.removeAttribute('hidden');
                        this.learnContent.classList.remove('hide');
                        this.learnBtn.setAttribute('aria-expanded','true');
                    } else {
                        this.learnContent.setAttribute('hidden','');
                        this.learnContent.classList.add('hide');
                        this.learnBtn.setAttribute('aria-expanded','false');
                    }
                });
            }
        }

        syncAddonState(){
            var isChecked = this.checkbox && this.checkbox.checked;
            this.hiddenInputs && this.hiddenInputs.forEach(function(input){ input.disabled = !isChecked; });
        }

        updateAddOn(variant) {
            if (!variant || !this.productData.variantAddOns) return;
            
            // find add-on data for current variant
            var variantAddOnData = this.productData.variantAddOns.find(function(item) {
                return item.id === variant.id;
            });
            
            var addOnData = variantAddOnData && variantAddOnData.addOn ? variantAddOnData.addOn : null;
            
            if (!addOnData) {
                // hide add-on if no data
                if (this.container) {
                    this.container.style.display = 'none';
                }
                return;
            }
            
            // show add-on and update content
            if (!this.container) {
                // create container if it doesn't exist
                this.innerHTML = '<div class="addon-product" data-addon></div>';
                this.container = this.querySelector('.addon-product');
            }
            this.container.style.display = '';
            
            // get product title from form or main element
            var productTitle = this.mainElement.querySelector('.product-title-design') ? 
                this.mainElement.querySelector('.product-title-design').textContent.trim() : '';
            var productId = this.mainElement.querySelector('form[data-productid]') ? 
                this.mainElement.querySelector('form[data-productid]').dataset.productid : '';
            
            // build add-on HTML
            var addonTitle = addOnData.customAddOnTitle || addOnData.addOnProductTitle || '';
            var addonDescription = addOnData.customAddOnDescription;
            var addonProductDescription = addOnData.addOnProductDescription || '';
            var ctaLabel = addOnData.ctaLabel || ('Add ' + addonTitle);
            var addonImage = addOnData.customAddOnImage;
            var addonProductImage = addOnData.addOnProductImage || '';
            var addonPrice = $s.formatMoney(addOnData.addOnVariantPrice);
            var addonGroupId = 'addon_' + productId + '_' + addOnData.addOnVariantId;
            var learnMoreLabel = 'learn more';
            
            // handle description - check if it's a string or object
            var descText = '';
            if (addonDescription) {
                if (typeof addonDescription === 'string') {
                    // strip HTML tags for display
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = addonDescription;
                    descText = tempDiv.textContent || tempDiv.innerText || '';
                } else if (addonDescription.value) {
                    // if it's an object with a value property
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = addonDescription.value;
                    descText = tempDiv.textContent || tempDiv.innerText || '';
                }
            }
            if (!descText && addonProductDescription) {
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = addonProductDescription;
                descText = tempDiv.textContent || tempDiv.innerText || '';
            }
            
            // handle image - use custom image first, then product image
            var imageUrl = '';
            var imageHeight = '';
            if (addonImage && typeof addonImage === 'string') {
                imageUrl = addonImage;
            } else if (addonImage && addonImage.src) {
                imageUrl = addonImage.src;
            } else if (addonProductImage && typeof addonProductImage === 'string') {
                imageUrl = addonProductImage;
            } else if (addonProductImage && addonProductImage.src) {
                imageUrl = addonProductImage.src;
            }
            
            var addonHtml = '<input class="addon-checkbox" type="checkbox" name="properties[_addonSelected]" value="true" aria-describedby="addon-learn-' + this.sectionId + '" id="addon-checkbox">';
            addonHtml += '<label class="addon-checkbox-label" for="addon-checkbox">';
            addonHtml += '<span>' + ctaLabel + ' (Only ' + addonPrice + ')';
            addonHtml += '<button type="button" class="addon-learn-more" id="addon-learn-' + this.sectionId + '" aria-expanded="false" aria-controls="addon-content-' + this.sectionId + '">' + learnMoreLabel + '</button>';
            addonHtml += '</span></label>';
            addonHtml += '<div id="addon-content-' + this.sectionId + '" class="addon-learn-content hide" hidden>';
            addonHtml += '<div class="addon-learn-body">';
            if (imageUrl) {
                addonHtml += '<img src="' + imageUrl + '" alt="' + addonTitle.replace(/"/g, '&quot;') + '" width="160" loading="lazy">';
            }
            addonHtml += '<div>';
            addonHtml += '<div class="addon-learn-title">' + addonTitle + '</div>';
            if (descText) {
                addonHtml += '<div class="addon-learn-desc">' + descText + '</div>';
            }
            addonHtml += '</div></div></div>';
            addonHtml += '<input type="hidden" name="items[0][id]" value="' + addOnData.addOnVariantId + '" disabled>';
            addonHtml += '<input type="hidden" name="items[0][_parent_id]" value="' + productId + '" disabled>';
            
            // only add cleanup properties if cleanup is enabled
            var cleanupEnabled = this.dataset.cleanupEnabled === 'true';
            if (cleanupEnabled) {
                addonHtml += '<input type="hidden" name="items[0][properties][_addon_parent_product_id]" value="' + productId + '" disabled>';
                addonHtml += '<input type="hidden" name="items[0][properties][_addon_group_id]" value="' + addonGroupId + '" disabled>';
                
                // update hidden input for addon group id in main form
                var groupIdInput = this.mainElement.querySelector('input[name="properties[_addon_group_id]"]');
                if (groupIdInput) {
                    groupIdInput.value = addonGroupId;
                } else {
                    var form = this.mainElement.querySelector('form');
                    if (form) {
                        var newInput = document.createElement('input');
                        newInput.type = 'hidden';
                        newInput.name = 'properties[_addon_group_id]';
                        newInput.value = addonGroupId;
                        form.appendChild(newInput);
                    }
                }
            }
            
            addonHtml += '<input type="hidden" name="items[0][properties][_addon_of_product]" value="' + productTitle.replace(/"/g, '&quot;') + '" disabled>';
            
            this.container.innerHTML = addonHtml;
            
            // rebind elements
            this.checkbox = this.container.querySelector('.addon-checkbox');
            this.hiddenInputs = this.container.querySelectorAll('input[type="hidden"]');
            this.learnBtn = this.container.querySelector('.addon-learn-more');
            this.learnContent = this.container.querySelector('#addon-content-' + this.sectionId);
            
            // rebind event listeners
            this.bind();
        }
    }
    customElements.define('product-add-on', ProductAddOn);
}

if (!customElements.get('product-swatch')) {
    class ProductSwatch extends HTMLElement {
        constructor() {
            super();
            this.mainElement = this.closest('.main-product-grid') || this.closest('.product-main-element');
            this.variantsElement = this.mainElement.querySelector('product-variants');
            this.optionNumber = this.dataset.option;
            this.label = this.dataset.label;
      
            this.buildOptionSelector();
          }
      
          buildOptionSelector() {
            var currentVariant = this.variantsElement.getCurrentVariant();
            var variantBundleTitle = this.mainElement.querySelector('.variant-bundle-title')
            
            var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
            var defaultValue = currentVariant.options[this.optionNumber-1];
              var optionElement = document.createElement('div');
                var html = `
                    <div class="option-name ${variantBundleTitle ? 'hide' : ''}">${this.label}: <span class="option-value">${defaultValue}</span></div>
                    <div class="swatch-group flex flex-wrap"></div>
                `;                
                this.innerHTML = html;
                this.buildOptions(optionValues, defaultValue);
          }
      
          buildOptions(options, defaultValue) {
              var html = '';
                options.forEach((option, index)=>{
                  if (!option.hiddenVariant) {
              var optionNameHandle = $s.handleize(this.label);
              var optionValueHandle = $s.handleize(option.value);
                    html += `
                <div class="swatch" data-available="${option.available}">
                  <input type="radio" id="swatch-${this.optionNumber}-${option.value}-${this.mainElement.dataset.section}" name="swatch-${this.optionNumber}-${this.mainElement.dataset.section}" value="${option.value}" />
                          <label for="swatch-${this.optionNumber}-${option.value}-${this.mainElement.dataset.section}">
                    <div class="label-inner ${optionNameHandle}-${optionValueHandle}">
                        <span>${option.value}</span>
                    </div>
                  </label>
                </div>
                    `;
                  }
                });
                var group = this.querySelector('.swatch-group');
                group.innerHTML = html;
                setTimeout(() => {
                    if(defaultValue && group.querySelector('input[value="'+defaultValue+'"]')) {
                        group.querySelector('input[value="'+defaultValue+'"]').checked = true;
                    } else {
                        group.querySelector('input').checked = true;
                    }
                }, 50);
          }
    }
    customElements.define('product-swatch', ProductSwatch);
}

if (!customElements.get('product-swatch-fragrance')) {
    class ProductSwatchFragrance extends HTMLElement {
        constructor() {
            super();
            this.mainElement = this.closest('.main-product-grid') || this.closest('.product-main-element');
            this.baseUrl = this.mainElement.dataset.baseUrl;
            this.productData = JSON.parse(this.mainElement.querySelector('[type="application/json"]').textContent);

            this.singleRow = this.mainElement.querySelector('.single-row');

            this.tabDescription = this.mainElement.querySelector('.tab-description');
            this.tabDescriptionFragrance = this.mainElement.querySelector('.tab-description-fragrance');
            this.tabFragrance = this.mainElement.querySelector('.tab-fragrance');
            this.tabIngredients = this.mainElement.querySelector('.tab-ingredients');
            this.tabPackaging = this.mainElement.querySelector('.tab-packaging');

            this.tabLinkDescriptionFragrance = this.mainElement.querySelector('#btn-description-fragrance');
            this.tabLinkDescription = this.mainElement.querySelector('#btn-description');
            this.tabLinkFragrance = this.mainElement.querySelector('#btn-fragrance');
            this.tabLinkIngredients = this.mainElement.querySelector('#btn-ingredients');
            this.tabLinkPackaging = this.mainElement.querySelector('#btn-packaging');

            //this.shippingDelay = this.mainElement.querySelector('.shipping-delay');
            this.variantsElement = this.closest('product-variants');
            this.optionNumber = this.dataset.option;
            this.productId = this.dataset.productid;
            this.label = this.dataset.label;

            this.mainProductInfo = this.closest('add-to-cart-form');
            this.headingFragrance = this.mainProductInfo.querySelector('.heading-fragrance');

            this.mainElement.addEventListener('variantChange', (e) => {
                if (e.detail.variant) {
                  const variant = e.detail.variant;
                  //const delay = variant.metafields.delay;

                  function getVariantDescription(variantId, data) {
                    const descriptionString = data.variantDescriptionMetafields.find(variantDescriptionMetafield => variantDescriptionMetafield.id == variantId);
                    if (!descriptionString) return '';
                    
                    return descriptionString.descriptionHTML;
                  }
                  
                  let htmlDescription = getVariantDescription(variant.id, this.productData);

                  /* We need to avoid extra line breaks */
                  //const description = variant.metafields.description ? htmlDescription.replaceAll(/(?:\r\n|\r|\n)/g, '<br>') : "";
                  const descriptionFragrance = variant.metafields.description ? htmlDescription : "";
                  const fragrance = variant.metafields.fragrance ? variant.metafields.fragrance.replaceAll(/(?:\r\n|\r|\n)/g, '<br>') : "";
                  const ingredients = variant.metafields.ingredients ? variant.metafields.ingredients.replaceAll(/(?:\r\n|\r|\n)/g, '<br>') : ""
                  const packaging = variant.metafields.packaging ? variant.metafields.packaging.replaceAll(/(?:\r\n|\r|\n)/g, '<br>') : ""

                  // Shipping Delay
                  // if (delay) {
                  //     this.shippingDelay.innerHTML = delay;
                  //     this.shippingDelay.classList.add('visible');
                  // } else {
                  //     this.shippingDelay.classList.remove('visible');
                  //     this.shippingDelay.innerHTML = '';
                  // }

                  this.getTabValue(descriptionFragrance, this.tabDescriptionFragrance, this.tabLinkDescriptionFragrance);
                  this.getTabValue(fragrance, this.tabFragrance, this.tabLinkFragrance);
                  this.getTabValue(ingredients, this.tabIngredients, this.tabLinkIngredients);
                  this.getTabValue(packaging, this.tabPackaging, this.tabLinkPackaging);

                  this.singleRow.querySelectorAll('.visible').forEach((el, i) => {
                      if (i === 0) el.click()
                  });
                }
            });

            this.buildOptionSelector();
            this.hoverOptionSelector();
        }

        getTabValue(tab, target, link) {
            if (tab) {
                target.innerHTML = tab;
                link.classList.add('visible');
            } else {
                link.classList.remove('visible');
                link.setAttribute('aria-selected', 'false');
                target.innerHTML = '';
            }
        }

        hoverOptionSelector() {
            var colorHover = this.variantsElement.querySelector('.color-hover');
            var swatchesWrap = this.variantsElement.querySelector('product-swatch-fragrance');
            var swatches = swatchesWrap.querySelector('.swatch-group');

            if (swatches)
                swatches.querySelectorAll('.swatch').forEach(el => {
                    el.addEventListener('mouseover', () => colorHover.innerHTML = el.querySelector('input').value, false);
                    el.addEventListener('mouseout', () => colorHover.innerHTML = '', false);
                });
        }

        buildOptionSelector() {
            var currentVariant = this.variantsElement.getCurrentVariant();
            var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber - 1];
            var defaultValue = currentVariant.options[this.optionNumber - 1];
            var optionElement = document.createElement('div');

            this.headingFragrance.innerHTML = defaultValue;

            var html = `
                    <div class="option-name">SELECT YOUR ${this.label}:</div>
                    <div class="swatch-group flex flex-wrap align-items-end"></div>
                `;
            this.innerHTML = html;
            this.buildOptions(optionValues, defaultValue);
        }

        buildOptions(options, defaultValue, currentVariant) {
            var html = '';
            options.forEach((option, index) => {
              if (!option.hiddenVariant){
                var optionNameHandle = $s.handleize(this.label);
                var optionValueHandle = $s.handleize(option.value);
                html += `
                    <div class="swatch" data-available="${option.available}">
                        <input class="visually-hidden" type="radio" id="swatch-${this.productId}-${optionValueHandle}" name="swatch-${this.productId}" value="${option.value}" />
                        <label class="animation color color-${optionValueHandle}" role="button" for="swatch-${this.productId}-${optionValueHandle}">
                            <span class="visually-hidden">${option.value}</span>
                        </label>
                    </div>
  			        `;
              }
            });
            
            html += `<div class="color-hover"></div>`;
            var group = this.querySelector('.swatch-group');        
            group.innerHTML = html;
            setTimeout(() => {
                if(defaultValue && group.querySelector('input[value="'+defaultValue+'"]')) {
                    group.querySelector('input[value="'+defaultValue+'"]').checked = true;
                } else {
                    group.querySelector('input').checked = true;
                }
            }, 50);
            
        }
    }
    customElements.define('product-swatch-fragrance', ProductSwatchFragrance);
}







if (!customElements.get('product-dropdown')) {
    class ProductDropdown extends HTMLElement {
        constructor() {
            super();
            this.variantsElement = this.closest('product-variants');
            this.optionNumber = this.dataset.option;
            this.label = this.dataset.label;

            this.buildOptionSelector();
        }

        buildOptionSelector() {
            var currentVariant = this.variantsElement.getCurrentVariant();
            var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber - 1];
            var defaultValue = currentVariant.options[this.optionNumber - 1];

            var optionId = this.parentElement.dataset.section + '-option-' + this.optionNumber;
            var optionElement = document.createElement('div');
            var html = `
  			<label class="option-name" for="${optionId}">${this.label}</label>
  			<select id="${optionId}"></select>
  		`;
            this.innerHTML = html;
            this.buildOptions(optionValues, defaultValue);
        }

        buildOptions(options, defaultValue) {
            var html = '';
            options.forEach((option, index) => {
                let soldOut = (!option.available ? ' - Sold Out' : '');
                html += `<option value="${option.value}">${option.value}${soldOut}</option>`;
            });
            var select = this.querySelector('select');
            select.innerHTML = html;

            if (defaultValue) {
                var newValueIndex = Array.from(select.options).findIndex(x => x.value == defaultValue);
                if (newValueIndex >= 0) {
                    select.selectedIndex = newValueIndex;
                }
            }
        }
    }
    customElements.define('product-dropdown', ProductDropdown);
}

if (!customElements.get('product-model')) {
    class ProductModel extends HTMLElement {
        constructor() {
            super();
            this.mainElement = document.getElementById('main-product-' + this.dataset['section']);
            this.productData = JSON.parse(this.mainElement.querySelector('[type="application/json"]').textContent);

            window.Shopify.loadFeatures([{
                name: 'shopify-xr',
                version: '1.0',
                onLoad: this.setupShopifyXr.bind(this)
            }]);
        }

        setupShopifyXr() {
            if (!window.ShopifyXR) {
                document.addEventListener('shopify_xr_initialized', () => {
                    this.setupShopifyXr();
                });
            } else {
                window.ShopifyXR.addModels(this.productData.media.filter(x => x.media_type == 'model'));
                setTimeout(() => {
                    window.ShopifyXR.setupXRElements();
                }, 100);
            }
        }
    }
    customElements.define('product-model', ProductModel);
}

if (!customElements.get('product-selling-plan')) {
    class ProductSellingPlan extends HTMLElement {
        constructor() {
            super();
            this.mainElement = this.closest('#main-product-' + this.dataset['section']);
            this.sectionId = this.dataset['section'];
            this.productData = JSON.parse(this.mainElement.querySelector('[type="application/json"]').textContent);
            this.input = this.querySelector('[name="selling_plan"]');
            this.groupsContainer = this.querySelector('[data-groups]');
            this.plansContainer = this.querySelector('[data-plans]');
            this.variantsElement = this.mainElement.querySelector('product-variants');

            this.input.addEventListener('change', () => {
                this.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', { detail: { sellingPlan: this.getCurrentPlan() } }));
            });

            this.mainElement.addEventListener('variantChange', (e) => {
                // update plans container position
                const plansContainerInGroups = this.groupsContainer.querySelector('.selling-plan-plans');
                if (plansContainerInGroups) {
                    this.groupsContainer.parentElement.insertBefore(plansContainerInGroups, this.groupsContainer.nextSibling);
                }
                
                this.groupsContainer.innerHTML = this.getGroupsHtml();
                var currentPlan = this.getCurrentPlan();

                this.groupsContainer.querySelectorAll('[name="purchase_option"]').forEach((groupInput) => {
                    groupInput.addEventListener('change', (e) => {   
                      /**
                       * This is checking if there is a select element already in plansContainer.
                       * By default there is one, so this will always return true, therefore
                       * the selling plans dropdown will appear for one time purchase
                       */       
                        const currentGroup = this.getCurrentGroup();
                        const groupOptionName = currentGroup && currentGroup.options[0].name;
                        const groupOptionHTML = currentGroup ? `<div class="group-option-name"><span class="small--hide">: </span>${groupOptionName}</div>` : "";

                        const groupOptionNameElement = document.querySelector('.group-option-name');

                        var plan = this.plansContainer.querySelector('select');
                        if(groupOptionNameElement) {
                          groupOptionNameElement.remove();
                        } else {
                          this.plansContainer.insertAdjacentHTML("beforebegin", groupOptionHTML);
                        }
                        
                        this.plansContainer.innerHTML = this.getPlansHtml(plan ? plan.options[plan.selectedIndex].text : '');
                      
                        // update plans container position and pre-select subscription option on refill products
                        const plansContainerInGroups = this.groupsContainer.querySelector('.selling-plan-plans');
                        if (plansContainerInGroups) {
                        this.groupsContainer.parentElement.insertBefore(plansContainerInGroups, this.groupsContainer.nextSibling);
                        }
                        
                        var currentVariant = this.variantsElement.getCurrentVariant();
                        let isRefillProduct = currentVariant && currentVariant.name.includes('Refill');
                        
                        const selectedOption = this.groupsContainer.querySelector('[name="purchase_option"]:checked');
                        const isSubscriptionSelected = selectedOption && selectedOption.closest('.selling-plan-option--subsave');
                        
                        if (isRefillProduct && isSubscriptionSelected) {
                            const subscriptionOption = selectedOption.closest('.selling-plan-option--subsave');
                            
                            if (subscriptionOption && this.plansContainer) {
                                subscriptionOption.insertAdjacentElement('afterend', this.plansContainer);
                            }
                        }
                        
                        var select = this.plansContainer.querySelector('select.enabled');
                        if (select) {
                            select.addEventListener('change', (e) => {
                                this.updateSellingPlan(e.target.value);
                            });

                            if (select.querySelector('option[value="' + this.input.value + '"]')) {
                                select.value = this.input.value;
                            }
                            select.dispatchEvent(new Event('change', { bubbles: true }));
                        } else {
                            this.updateSellingPlan("");
                        }
                    });
                });
                
                if (currentPlan) {
                    var groupInput = this.groupsContainer.querySelector('[value="' + currentPlan.selling_plan_group_id + '"]');
                } else {
                    var groupInput = this.groupsContainer.querySelector('[name="purchase_option"]');
                }
                
                // pre-select subscription option on refill products
                var currentVariant = this.variantsElement.getCurrentVariant();
                let isRefillProduct = currentVariant && currentVariant.name.includes('Refill');
                if (isRefillProduct) {
                var subscriptionInput = this.groupsContainer.querySelector('.selling-plan-option--subsave input[type="radio"]');
                if (subscriptionInput) {
                    subscriptionInput.checked = true;
                    groupInput = subscriptionInput;
                } else {
                    var onetimeInput = document.querySelector('.selling-plan-option--onetime input');
                    if (onetimeInput) { onetimeInput.checked = true; groupInput = onetimeInput; }
                }
                } else {
                    var onetimeInput = this.groupsContainer.querySelector('.selling-plan-option--onetime input[type="radio"]');
                    if (onetimeInput) {
                        onetimeInput.checked = true;
                        groupInput = onetimeInput;
                    }
                }
                
                groupInput.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }

        updateSellingPlan(sellingPlanId) {
            this.input.value = sellingPlanId;
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        getGroupsHtml() {
            var currentVariant = this.variantsElement.getCurrentVariant();
            var html = '';

            if (!this.productData.requiresSellingPlan) {
                let optionId = `plan-option-onetime-${this.sectionId}`;
                let optionPrice = $s.formatMoney(currentVariant.price).replace('.00', '');
                html = `
          <div class="selling-plan-option selling-plan-option--onetime">
            <input type="radio" name="purchase_option" value="" id="${optionId}">
            <!--
            <label for="${optionId}" class="onetime-control-version">Buy Once <span class="option-price"> - ${optionPrice}</span></label>
            -->
            <label for="${optionId}" class="onetime-variation-version">Buy Once ${optionPrice + ' <span class="plus-shipping">+ SHIPPING</span>'}</label>
          </div>
        `;

            }
            if (currentVariant) {
                const filteredSellingPlanGroups = this.productData.sellingPlanGroups.filter(group => group.app_id !== "294517");
                filteredSellingPlanGroups.forEach((group) => {
                    let priceAdjustment = group.selling_plans[0].price_adjustments;
                    let discount = (priceAdjustment && priceAdjustment.length > 0 ? priceAdjustment[0].value : 0); //%
                    let planAlloc = currentVariant.selling_plan_allocations.find(x => x.selling_plan_group_id == group.id);
                    let subSaveTxt = document.getElementById("subscribe-save-txt").innerText;
                  
                    if (planAlloc && planAlloc.selling_plan_id !== 11559436439) {
                        let optionId = `plan-option-${group.id}-${this.sectionId}`;
                        let optionPrice = $s.formatMoney(planAlloc.price).replace('.00', '');


                        html += `
              <div class="selling-plan-option selling-plan-option--subsave">
                <input type="radio" name="purchase_option" value="${group.id}" id="${optionId}">
                <label for="${optionId}" class="subscription-variation-version">` + (discount ? subSaveTxt + ' <span class="option-discount">' + discount + '%</span>' + '<span><span class="subscribe-compare-at">'+ $s.formatMoney(planAlloc.compare_at_price).replace('.00', '') + '</span> ' + $s.formatMoney(planAlloc.price).replace('.00', '') + ' + FREE SHIPPING</span>' : 'Subscribe') + `<span class="edit-subscription-message">edit, pause, cancel anytime</span></label>
              </div>
            `;

                    }
                });
            }
            return html;
        }

        getPlansHtml(selectedName) {
            var currentVariant = this.variantsElement.getCurrentVariant();
            var enabled = true;
            var currentGroup = this.getCurrentGroup()
            if (!currentGroup) {
                /**
                 * This defaults to the first group even if one time purchase
                 * is selected
                 */
                //currentGroup = this.productData.sellingPlanGroups[0];
                enabled = false;
            }
            var html = '';

            if (currentGroup) {
              console.log("currentGroup: ", currentGroup);
                selectedName = selectedName ? selectedName.trim() : currentGroup.selling_plans[0].name.trim();                
                html = `<select ` + (enabled ? 'class="enabled"' : '') + `>`;
            
                currentVariant.selling_plan_allocations.forEach((plan) => {
                    // Check if a matching selling plan exists
                    var sellingPlan = currentGroup.selling_plans.find(x => x.id == plan.selling_plan_id);
                    
                    if (sellingPlan) {

                        html += `<option value="${sellingPlan.id}"  ` + 
                                (selectedName == sellingPlan.name.trim() ? 'selected="selected"' : '') + 
                                `>${sellingPlan.name}</option>`;
                    } else {
                        console.log('No matching selling plan found for allocation:', plan.selling_plan_id);
                    }
                });
            
                html += `</select>`;
            }


            return html;
        }

        getCurrentPlan() {
            var currentVariant = this.variantsElement.getCurrentVariant();
            if (currentVariant) {
                return currentVariant.selling_plan_allocations.find(x => x.selling_plan_id == this.input.value);
            }
            return false;
        }

        getCurrentGroup() {
            var groupId = this.querySelector('[name="purchase_option"]:checked').value;
            return this.productData.sellingPlanGroups.find(x => x.id == groupId);
        }

        getCurrentVariant() {
            return this.variantsElement.getCurrentVariant();
        }
    }
    customElements.define('product-selling-plan', ProductSellingPlan);
}